import { StaticImage } from 'gatsby-plugin-image';

export const Hero = ({ isFull }) => (
  <section className="hero">
    {isFull ? (
      <StaticImage
        src="../../images/seeds-of-growth-hero.png"
        alt=""
        placeholder="none"
      />
    ) : (
      <StaticImage src="../../images/mini-hero.png" alt="" placeholder="none" />
    )}
  </section>
);
